const PI = Math.PI;

//纬度转换
function transformLatitude(x, y) {
    let num = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    num += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    num += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
    num += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
    return num;
}
//经度转换
function transformLongitude(x, y) {
    let num = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    num += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
    num += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
    num += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
    return num;
}
// 坐标转换
function calculation(longitude, latitude) {
    let a = 6378245.0; // 卫星椭球坐标投影到平面地图坐标系的投影因子。
    let ee = 0.00669342162296594323; // 椭球的偏心率。
    let lat = transformLatitude(longitude - 105.0, latitude - 35.0);
    let lng = transformLongitude(longitude - 105.0, latitude - 35.0);
    let radLat = latitude / 180.0 * PI;
    let magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    let sqrtMagic = Math.sqrt(magic);
    lat = (lat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI);
    lng = (lng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI);
    return {
        'longitude': lng,
        'latitude': lat,
    };
}
// 判断是否为国外坐标
function isOutOfChina(longitude, latitude) {
    if (longitude < 72.004 || longitude > 137.8347) {
        return true;
    }
    if (latitude < 0.8293 || latitude > 55.8271) {
        return true;
    }
    return false;
}
// GPS坐标 转 GCJ02坐标
export function GPS2GCJ02(longitude, latitude) {
    longitude = Number(longitude);
    latitude = Number(latitude);
    if (isOutOfChina(longitude, latitude)) {
        //国外
        return [longitude + obj.longitude,
        latitude + obj.latitude,
        ];
    } else {
        //国内
        let obj = calculation(longitude, latitude);
        return [longitude + obj.longitude,
        latitude + obj.latitude,
        ];
    }
}